/**
 * @typedef {Object} waitUntilOptions
 *
 * @property {number} [timeoutAfter=1000] The promise will be rejected after this number of milliseconds
 * @property {number} [msBetweenAttempts=1] The value that will be passed to setTimeout for each attempt
 */

/**
 * Return a promise that will not resolve until the test
 * function returns true, up to a timeout specified in options
 *
 * @param testFunction
 * @param {waitUntilOptions} [options]
 */
function waitUntil(testFunction, options) {

    const defaultOptions = {
        timeoutAfter: 0,
        msBetweenAttempts: 1,
    }

    if(!options){
        options = {};
    }

    const finalOptions = {
        ...defaultOptions,
        ...options
    };

    // Store time at init
    finalOptions._startTime = Date.now();


    return new Promise((resolve, reject) => {
        checkIfReady(testFunction, finalOptions, resolve, reject);
    })
}

function checkIfReady(testFunction, options, resolve, reject) {
    const ready = testFunction();
    if (ready) {
        resolve();
    } else {
        // Check if there is a timeout...
        if (options.timeoutAfter) {
            const timeElapsed = Date.now() - options._startTime;

            if (timeElapsed >= options.timeoutAfter) {
                // ... and we reached it
                reject('Timeout was reached before resolving');
                return;
            }
        }
        setTimeout(
            () => checkIfReady(testFunction, options, resolve, reject),
            options.msBetweenAttempts
        );
    }
}

export {waitUntil}
